import React from "react";
import './SubPageHeader.css'
export const SubPageHeader = ({title}) => {
    return (
        <div className='sub-page-header'>
            <div className='sub-page-header-image'/>
            <div className='sub-page-header-overlay'/>
            <div className='sub-page-header-content'>
                <h1>{title}</h1>
                <h2>A Christ Centered, Spirit Filled New Creation Church</h2>
            </div>
        </div>
    )
}